<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="assignationForm" @submit="submitAssign" :validation-schema="assignationSchema">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane"
              type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Information générale</button>
          </li>
          <!-- <li class="nav-item" role="presentation">
            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane"
              type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Méta data</button>
          </li> -->
        </ul>
        <div class="tab-content" id="myTabContent ">
          <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Organes <span class="text-danger">*</span>
                  </label>
                  <Field name="organes" v-slot="{ field }">
                    <Multiselect :options="organesOptions" :searchable="true" multiple="false" data-mode="organes"
                      track-by="value" label="label" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner l'organe" @change="onOrganeChange" />
                  </Field>
                  <ErrorMessage name="organes" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Mandatures <span class="text-danger">*</span>
                  </label>
                  <Field name="mandatures" v-slot="{ field }">
                    <Multiselect :options="mandaturesOptions" :searchable="true" multiple="false" data-mode="mandatures"
                      track-by="label" label="label" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner la mandature" />
                  </Field>
                  <ErrorMessage name="mandatures" class="text-danger" />
                </div>
              </div>

            </div>
            <div v-if="postes?.length > 0" class="col-md-12">
              <h5>Liste des postes :</h5>


              <div class="row g-2">
                <!-- {{ postes }} -->
                <div v-for="poste in postes" :key="poste.id" class="col-md-6">

                  <div class="modal fade" :id="`addMemberModal_${poste.id}`" tabindex="-2" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;">
                      <div class="modal-content">
                        <!-- Header -->
                        <div class="modal-header justify-content-center text-center border-0 ">
                          <h5 class="modal-title" style="text-decoration: underline;">Formulaire d'ajout d'un membre
                          </h5>
                          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button> -->
                        </div>
                        <!-- Body -->
                        <div class="modal-body">
                          <div class="row justify-content-center">
                            <div class="col-md-8 mb-3">
                              <label class="form-label">Nom :</label>
                              <input type="text" class="form-control" v-model="poste.membre.nom"
                                placeholder="Entrez un nom">
                            </div>
                            <div class="col-md-8 mb-3">
                              <label class="form-label">Prénom :</label>
                              <input type="text" class="form-control" v-model="poste.membre.prenom"
                                placeholder="Entrez un prénom">
                            </div>
                            <div class="col-md-8 mb-3">
                              <label class="form-label">Image :</label>
                              <input type="file" class="form-control" @input="(e) => onImageChange(poste, e)">

                            </div>
                          </div>
                          <!-- Footer -->
                          <div class="modal-footer justify-content-center">
                            <button type="button" class="btn btn-primary" @click="addNewMembre(poste)">Ajouter le
                              membre</button>
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <strong>{{ poste.nomPoste }}</strong>
                    <button type="button" class="btn btn-sm btn-warning align-self-start"
                      style="color: white; font-size: 10px;" data-bs-toggle="modal"
                      :data-bs-target="`#addMemberModal_${poste.id}`" @click="currentPosteId = poste.id">
                      Ajouter+
                    </button>
                  </div>

                  <div class="d-flex flex-column gap-1">
                    <!-- <Field name="Membre" v-slot="{ field }"> -->
                    <Multiselect :options="membresOptions" :searchable="true" :multiple="false" data-mode="membres"
                      track-by="value" label="label" v-model="poste.selectedMembre"
                      placeholder="Sélectionner un membre" />
                    <!-- </Field> -->
                    <ErrorMessage name="membres" class="text-danger" />
                  </div>

                </div>
              </div>
            </div>



          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium 
                  text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Valider les assignations
              </button>
              <router-link to="/liste-assignation" 
                    class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>

      </Form>

    </div>

  </div>
</template>

<script lang="ts">
import Multiselect from "@vueform/multiselect";
import { Form, Field, ErrorMessage } from "vee-validate";
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import { PostMembreMandature } from "@/models/postemembremandature";
import { Postes } from "@/models/Postes"
import ApiService from "@/services/ApiService";
import axios from "axios";
import Swal from 'sweetalert2'
import { Modal } from "bootstrap";
import { Reactive } from "vue";

export default defineComponent({
  name: "submitAssign",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: (props, { emit }) => {
    const assignationSchema = Yup.object().shape({
      organes: Yup.string().required("L’organe est obligatoire"),
      mandatures: Yup.string().required("La mandature est obligatoire"),
    });
    const assignationForm = ref<PostMembreMandature | null>(null)
    const router = useRouter();
    const organesOptions = ref([]);
    interface MembreOption {
      value: number;
      label: string;
      nom: string;
      prenom: string;
      urlImage?: string | null;
      isTemporary?: boolean;
      file?: File | null;
    }
    const currentPosteId = ref<number | null>(null);
    const membresOptions = ref<MembreOption[]>([]);
    const mandaturesOptions = ref([]);
    // const postes = ref<Postes[]>([])
    // const selectedOrgane = ref(null);
    const postes = ref<Array<{
      id: number; nomPoste: string, selectedMembre: any | null, membre: {
        nom: string,
        prenom: string,
        urlImage: File | null
      }
    }>>([]);
    const selectedOrgane = ref<null | {
      value: number;
      label: string;
      postes: Array<{ id: number; nomPoste: string; }>;
    }>(null);
    const nom = ref("");
    const prenom = ref("");
    const newImage = ref<File | null>(null);


    onMounted(() => {
      fetchOrganes();
      fetchMandatures();
      fetchMembres();
    })

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    }

    const fetchOrganes = async () => {
      try {
        const response = await ApiService.get('/organes?limit=0');
        console.log("responseeeeeeee", response);
        const organeData = response.data.data;
        organesOptions.value = organeData.map((organes) => ({
          value: organes.id,
          label: `${organes.nom}`,
          postes: organes.postes || [],

        }));

      } catch (error) {
        //
      }
    };

    const fetchMandatures = async () => {
      try {
        const response = await ApiService.get('/mandature');
        console.log("Mandature response", response);
        const mandatureData = response.data.data.data;
        mandaturesOptions.value = mandatureData.map((mandatures) => ({
          value: mandatures.id,
          label: `${mandatures.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchMembres = async () => {
      try {
        const response = await ApiService.get('/membre');
        console.log("Membre response", response);
        const membreData = response.data;
        membresOptions.value = membreData.map((membres) => ({
          value: membres.id,
          label: `${membres.nom} ${membres.prenom}`,

        }));

      } catch (error) {
        //
      }
    }


    const onOrganeChange = (organeId: any) => {
      const selected = (organesOptions.value as any[]).find(o => o.value === organeId);
      if (selected) {
        selectedOrgane.value = selected;
        postes.value = selected.postes.map((p: any) => reactive({
          id: p.id,
          nomPoste: p.nomPoste,
          selectedMembre: null,
          membre: {
            nom: null,
            prenom: null,
            urlImage: null
          }
        }));
      } else {
        postes.value = [];
      }
    };


    const onImageChange = (poste: any, event: Event) => {
      const target = event.target as HTMLInputElement;
      if (!target || !target.files || target.files.length === 0) {
        poste.membre.urlImage = null;
        console.log(`❌ Aucun fichier sélectionné pour poste ${poste.id}`);
        return;
      }
      
      const file = target.files[0];
      poste.membre.urlImage = file;
      console.log(`✅ Fichier sélectionné pour poste ${poste.id}:`, {
        name: file.name,
        size: file.size,
        type: file.type
      });
    };


    const addNewMembre = (poste: any) => {
      if (!poste.membre.nom || !poste.membre.prenom) {
        Swal.fire({
          title: "Remplissez les champs",
          icon: "error",
          draggable: true,
        });
        return;
      }


      // Créer le membre
      const newMembreObj: any = {
        value: -poste.id,
        label: `${poste.membre.nom} ${poste.membre.prenom}`,
      };

      // Ajouter à l'option
      membresOptions.value.push(newMembreObj);
      poste.selectedMembre = -poste.id;


      // Fermer le modal
      const modalEl = document.getElementById('addMemberModal_' + poste.id);
      if (modalEl) {
        const modalInstance = Modal.getInstance(modalEl) || new Modal(modalEl);
        modalInstance.hide();
      }


      Swal.fire({
        title: "Membre ajouté temporairement",
        icon: "success",
        draggable: true,
      });
    };

    const submitAssign = async (values, { resetForm }) => {
      try {
        const mandatureId = values.mandatures;
        const organeId = values.organes;
        let payload = {};


        const assignations = postes.value.map((p) => {
          if (parseInt(p.selectedMembre) > 0) {
            return {
              posteId: p.id,
              membre: {
                id: p.selectedMembre,
                nom: p.membre.nom,
                prenom: p.membre.prenom,
                urlImage: p.membre.urlImage,
              },
            };
          } else {
            return {
              posteId: p.id,
              membre: {
                id: null,
                nom: p.membre.nom,
                prenom: p.membre.prenom,
                urlImage: p.membre.urlImage,
              },
            };
          }
        });

        
        const hasAssignments = postes.value.some(p => 
          p.selectedMembre || (p.membre.nom && p.membre.prenom)
        );

        if (!hasAssignments) {
          Swal.fire({
            title: "Veuillez assigner au moins un poste à un membre",
            icon: "error",
            draggable: true,
          });
          return;
        }

        // Validate new members have required fields
        const invalidNewMembers = postes.value.filter(p => 
          p.selectedMembre && parseInt(p.selectedMembre) < 0 && 
          (!p.membre.nom || !p.membre.prenom)
        );

        if (invalidNewMembers.length > 0) {
          Swal.fire({
            title: "Tous les nouveaux membres doivent avoir un nom et un prénom",
            icon: "error",
            draggable: true,
          });
          return;
        }
        const formData = new FormData();

        // Toujours ajouter mandatureId et assignations
        formData.append('mandatureId', mandatureId.toString());
        formData.append('assignations', JSON.stringify(assignations));
        
        console.log('=== DONNÉES AVANT ENVOI ===');
        console.log('MandatureId:', mandatureId);
        console.log('Assignations data:', assignations);
        console.log('Postes avec fichiers:');
        postes.value.forEach(poste => {
          if (poste.membre.urlImage) {
            console.log(`  Poste ${poste.id}:`, {
              nom: poste.membre.nom,
              prenom: poste.membre.prenom,
              selectedMembre: poste.selectedMembre,
              fileType: typeof poste.membre.urlImage,
              fileName: poste.membre.urlImage?.name || 'N/A'
            });
          }
        });
        
        // Ajouter les fichiers pour les nouveaux membres
        postes.value.forEach(poste => {
          console.log(`Vérification poste ${poste.id}:`, {
            selectedMembre: poste.selectedMembre,
            hasImage: !!poste.membre.urlImage,
            imageType: typeof poste.membre.urlImage,
            isFile: poste.membre.urlImage instanceof File
          });
          
          if (poste.selectedMembre && parseInt(poste.selectedMembre) < 0 && poste.membre.urlImage instanceof File) {
            formData.append(`image_${poste.id}`, poste.membre.urlImage, poste.membre.urlImage.name);
            console.log(`✅ Fichier ajouté pour poste ${poste.id}:`, poste.membre.urlImage.name);
          } else if (poste.selectedMembre && parseInt(poste.selectedMembre) < 0) {
            console.log(`⚠️ Poste ${poste.id} est un nouveau membre mais pas de fichier image valide`);
          }
        });
        // payload["assignations"] = assignations
        // payload["mandatureId"] = mandatureId

        // postes.value.forEach(poste => {
        //   if (poste.selectedMembre < 0) {
        //     payload[`moduleFichier_${poste.id}`] = poste.membre.urlImage
        //   }
        // });
      
        console.log("FormData contents:");
        for (let [key, value] of formData.entries()) {
          console.log(key, value);
        }
        
        // Vérifier que FormData n'est pas vide
        const formDataEntries = Array.from(formData.entries());
        if (formDataEntries.length === 0) {
          console.error("FormData est vide!");
          Swal.fire({
            title: "Erreur: Aucune donnée à envoyer",
            icon: "error",
            draggable: true,
          });
          return;
        }
        
        // S'assurer que l'ApiService est configuré avec le bon token
        ApiService.setHeader();
        
        console.log("=== DEBUG INFO ===");
        console.log("MandatureId:", mandatureId, "Type:", typeof mandatureId);
        console.log("Assignations:", assignations);
        console.log("FormData size:", formDataEntries.length);
        
        // Option 1: Essayer avec ApiService
        let response;
        try {
          console.log("🚀 Tentative avec ApiService.postWithFile");
          response = await ApiService.postWithFile("/postmandaturembr", formData);
          console.log("✅ Succès avec ApiService:", response);
        } catch (apiError) {
          console.error("❌ Échec avec ApiService:", apiError);
          // Option 2: Essayer avec axios direct en cas d'échec
          console.log("🚀 Tentative avec axios direct...");
        }
        
        Swal.fire({
          title: "Assignations ajoutées avec succès",
          icon: "success",
          draggable: true,
        });
        console.log("Réponse finale :", response.data);

        resetForm();
      } catch (error) {
        console.error("Erreur lors de l’envoi :", error);
        Swal.fire({
          title: "Erreur",
          icon: "error",
          draggable: true,
        });
      }
    };



    return {
      assignationSchema,
      assignationForm,
      submitAssign,
      organesOptions,
      membresOptions,
      mandaturesOptions,
      postes,
      selectedOrgane,
      addNewMembre,
      onOrganeChange,
      getCurrentDate,
      onImageChange,
      nom,        // <-- ajouté
      prenom,     // <-- ajouté
      newImage,
      currentPosteId
    };

  }
})
</script>